import { useMutation } from '@tanstack/react-query';
import { useState, type FormEvent } from 'react';

import { Button, Card, useToast } from '../../components/ui';
import { useMemberAuth } from '../../context/MemberAuthContext';
import { api, errorMessage } from '../../lib/api';

export function Preferences() {
  const { me, refetch } = useMemberAuth();
  const toast = useToast();
  const [emailEnabled, setEmailEnabled] = useState(me?.emailEnabled ?? true);
  const [smsEnabled, setSmsEnabled] = useState(me?.smsEnabled ?? false);

  const save = useMutation({
    mutationFn: async () => {
      await api.patch('/public/me/preferences', { emailEnabled, smsEnabled });
    },
    onSuccess: async () => {
      toast.push('Preferences updated', 'success');
      await refetch();
    },
    onError: (err) => toast.push(errorMessage(err), 'error'),
  });

  if (!me) return null;

  return (
    <div className="space-y-4">
      <h1 className="font-display text-3xl">Preferences</h1>
      <Card className="p-5">
        <form
          onSubmit={(e: FormEvent) => {
            e.preventDefault();
            save.mutate();
          }}
          className="space-y-4"
        >
          <label className="flex items-center gap-3">
            <input type="checkbox" checked={emailEnabled} onChange={(e) => setEmailEnabled(e.target.checked)} />
            <span>Email notifications</span>
          </label>
          <label className="flex items-center gap-3">
            <input
              type="checkbox"
              checked={smsEnabled}
              disabled={!me.smsConsentAt}
              onChange={(e) => setSmsEnabled(e.target.checked)}
            />
            <span>
              SMS notifications {!me.smsConsentAt && <em className="text-ink-muted">(consent required first)</em>}
            </span>
          </label>
          <Button type="submit" loading={save.isPending}>
            Save
          </Button>
        </form>
      </Card>
    </div>
  );
}
